import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  SEARCH,
  GET_ALL_SELECTS_REQUEST,
  GET_ALL_SELECTS_SUCCESS,
  SET_LOADING_SELECTS,
  GET_ID_MODAL_FEEDBACK_REQUEST,
  SET_LOADING_MODAL_FEEDBACK,
  GET_ID_MODAL_FEEDBACK_SUCCESS,
  SHARE_CSV
} from './client-visit-constants';

import { ClientVisitFeedbackResponseInterface } from './client-visit-interface';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const setLoadingModalFeedback = (loading: Boolean) => {
  return {
    type: SET_LOADING_MODAL_FEEDBACK,
    loading
  };
};

export const getAllRequest = filters => {
  return {
    type: GET_ALL_REQUEST,
    filters
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const getAllSelectsRequest = (client?: string) => {
  return {
    type: GET_ALL_SELECTS_REQUEST,
    client
  };
};

export const getAllSelectsSuccess = (payload: any) => {
  return {
    type: GET_ALL_SELECTS_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setRowsOrientation = (rowsOrientation: string) => {
  return {
    type: SET_ROWS_ORIENTATION,
    rowsOrientation
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};

export const getModalFeedbackRequest = (client: { id: string; name: string; clientName: string }) => {
  return {
    type: GET_ID_MODAL_FEEDBACK_REQUEST,
    client
  };
};

export const getModalFeedbackSuccess = (payload: ClientVisitFeedbackResponseInterface) => {
  return {
    type: GET_ID_MODAL_FEEDBACK_SUCCESS,
    payload
  };
};

export const shareCsv = (exportType: 'csv' | 'xlsx', filters) => {
  return {
    type: SHARE_CSV,
    exportType,
    filters
  };
};
